<template>
  <div :class="{ desaturate }" class="challenge-card">
    <app-image
      height="20px"
      :src="challengeResource.icon"
      :width="'fit-content'"
      class="app-image"
    />
    <div class="challenge-title">{{ challengeResource.title }}</div>
    <div class="challenge-subtitle">{{ challengeResource.tagline }}</div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import type { PropType } from 'vue';
import type { IChallenge, IChallengeResource } from '@rready/sdk';

export default Vue.extend({
  name: 'ChallengeCard',
  props: {
    challenge: {
      type: Object as PropType<IChallenge>,
      required: true
    },
    completionDate: {
      type: String,
      required: false
    },
    desaturate: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    challengeResource(): IChallengeResource {
      return this.$res(this.challenge.achievement.resources) ?? {};
    }
  }
});
</script>

<style lang="scss" scoped>
@use '@rready/design/dist/assets/utils.scss';

.challenge-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 136px;
  width: 100%;
  min-width: 231px;
  padding: var(--space-4);
  border-radius: var(--radius-2);
  box-shadow:
    0 0 16px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.07);
  transition:
    box-shadow 0.3s ease-in-out,
    filter 0.3s ease-in-out;

  &.desaturate {
    filter: saturate(0);
  }

  &:hover {
    box-shadow:
      0 0 16px rgba(0, 0, 0, 0.3),
      0 2px 24px rgba(0, 0, 0, 0.01);
    filter: saturate(1);
  }

  .app-image {
    flex-shrink: 0;
  }

  .challenge-title {
    margin-top: 4px;
    font-weight: 500;
    font-size: var(--font-size-small);
    color: var(--color-black);
    @include utils.line-clamp(1);
  }

  .challenge-subtitle {
    font-size: 13px;
    color: var(--color-grey-light-2);
    @include utils.line-clamp(2);
  }
}
</style>
